import {
  Component,
  Input
} from '@angular/core';

@Component({
  selector: 'cn-button',
  templateUrl: './cn-button.html'
})
export class CNButtonComponent {

  @Input() disabled: boolean;
  @Input() outline: boolean;

  constructor( ) { }

}



// WEBPACK FOOTER //
// ./src/components/cn-button/cn-button.component.ts